import { SELECT_DOCTOR } from "../constants/select-doctor";
import { Action } from "../models/select-doctor";
import { Doctor } from "../types";

function data(state: Partial<Doctor> = {}, action: Action): Partial<Doctor> {
  switch (action.type) {
    case SELECT_DOCTOR:
      return action.payload;
    default:
      return state;
  }
}

export default data;
